import store from 'app/store'
import { authCreateActions } from 'app/store/auth/authSlice'
import { CrossStorageClient } from 'cross-storage'

import { WEBAPP_ASSET } from '../constants/env.const'
import { LOCAL_STORAGE } from '../constants/localStorage.const'
import { parseJwt } from './utils'

let crossStorageClient: CrossStorageClient | null = null

const getCrossStorageClient = () => {
  if (!crossStorageClient) {
    crossStorageClient = new CrossStorageClient(`${WEBAPP_ASSET}/hub.html`, { timeout: 10000 })
  }
  return crossStorageClient
}

const handleError = (error: unknown) => console.debug('CrossStorage Error:', error)

export const crossStorageUtils = {
  setAccessToken: async (accessToken: string) => {
    localStorage.setItem(LOCAL_STORAGE.ACCESS_TOKEN, accessToken)
    const tokenInfo = parseJwt(accessToken)
    store.dispatch(authCreateActions.updateCustomer({ currentCompanyId: tokenInfo.company_id }))
    try {
      const storage = getCrossStorageClient()
      await storage.onConnect()
      return storage.set(LOCAL_STORAGE.ACCESS_TOKEN, accessToken)
    } catch (error) {
      handleError(error)
    }
  },

  handleConnectCrossStorage: async (callback?: (token: string) => void) => {
    try {
      const storage = getCrossStorageClient()
      await storage.onConnect()
      const accessToken = await storage.get(LOCAL_STORAGE.ACCESS_TOKEN)

      if (accessToken) {
        await crossStorageUtils.setAccessToken(accessToken)
        callback?.(accessToken)
      }
    } catch (error) {
      handleError(error)
    }
  },

  handleInitToken: async () => {
    const authenticationToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN) || ''

    try {
      const storage = getCrossStorageClient()
      await storage.onConnect()
      const accessToken = await storage.get(LOCAL_STORAGE.ACCESS_TOKEN)

      let token = authenticationToken

      if (!accessToken) {
        window.location.href = '/?isLogout=true'
      }

      if (accessToken && authenticationToken && accessToken !== authenticationToken) {
        const assetToken = parseJwt(accessToken)
        const authToken = parseJwt(authenticationToken)

        if (assetToken?.iat > authToken?.iat) {
          token = accessToken
        }
      }

      await crossStorageUtils.setAccessToken(token)
    } catch (error) {
      handleError(error)
    }
  },
}
